export default __webpack_public_path__ + "hero-xxl-01c449e72a1244ac7635ddeb95085c57.digested.webp";